import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
import { ArrowLeftIcon, PaletteIcon, PenToolIcon, LayersIcon, UserIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidLoisPage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2858" data-mp="22xlufuioeoiz">
      <SEO title="Loïs Bruins, Junior Vormgever | Noord Digital" description="Maak kennis met Loïs Bruins, Junior Vormgever bij Noord Digital. Vertaalt strategie en merk naar visueel werk dat klopt en converteert." canonical="https://noorddigital.nl/over-ons/lois" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Loïs Bruins',
      path: '/over-ons/lois'
    }])} data-id="element-2859" data-mp="1y0bv9n5hiyhy" />
      <Header data-id="element-2860" data-mp="2grcyindn1g7b" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2861" data-mp="2grwfa0rjxyjr">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2862" data-mp="1k9ea49f5dnrq">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2863" data-mp="1kb8xrvhsztzi">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2864" data-mp="1u60ukx3kact8" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2865" data-mp="1z6f5qo0gm2vh">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2866" data-mp="237ql80pmd7py">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5] flex items-center justify-center shadow-lg overflow-hidden" data-id="element-2867" data-mp="235nwrl447mnc">
                <img src="https://cdn.magicpatterns.com/uploads/o7QWtdg1j2daqsFksK5e45/WhatsApp_Image_2026-06-15_at_17.03.57_-_Copy.jpg" alt="Loïs Bruins" className="w-full h-full object-cover" style={{
                objectPosition: 'center 25%'
              }} data-id="element-2868" data-mp="2czmwkdgpuuc4" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2869" data-mp="2qv8kehb7r82y">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2870" data-mp="rs1lfl4oerzt">
                Loïs Bruins
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2871" data-mp="murtnytte48t">
                Junior Vormgever
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2872" data-mp="10mzk78ui8yz2">
                <p className="mb-4" data-id="element-2873" data-mp="vtd4t8wyigzk">
                  Als Junior Vormgever bij Noord Digital maak ik de designs voor
                  onze projecten. Van website-pagina's tot social posts en
                  campagnemateriaal: ik zorg dat het er strak en consistent
                  uitziet.
                </p>
                <p className="mb-4" data-id="element-2874" data-mp="1jj7jzx4r0hmz">
                  Ik vertaal de strategie en het merk van een klant naar visueel
                  werk dat klopt. Niet alleen mooi, maar ook duidelijk, zodat de
                  juiste boodschap meteen overkomt en bezoekers weten wat ze
                  moeten doen.
                </p>
                <p data-id="element-2875" data-mp="3hbvb4shrn5yv">
                  Ik leer elke dag bij van het team en werk graag mee in
                  iteraties. Feedback is geen kritiek maar materiaal om het
                  ontwerp scherper te maken.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2876" data-mp="2xezdb1szp0a6">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2877" data-mp="32danxer3zetg">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2878" data-mp="2ngjk8taejgy1">
                  <PaletteIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2879" data-mp="2sgxumhzh72z8" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2880" data-mp="2egwksd18gl7m">Visueel ontwerp</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2881" data-mp="2jfzr00sy8xh6">
                  <PenToolIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2882" data-mp="2jhu9z9knufim" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2883" data-mp="cq31beo4jjuc">Branding</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2884" data-mp="ho4h9qq9731l">
                  <LayersIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2885" data-mp="2dqpwm6ae9p5i" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2886" data-mp="28s6dedn6qrgu">Web design</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2887" data-mp="23stntl4xj6ak">
                Neem contact op met Loïs
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2888" data-mp="1q2gg9jvy9tlr" />
    </div>;
};